// extracted by mini-css-extract-plugin
export var divider = "_ks-0";
export var systemMessage = "_ks-1";
export var systemMessageWrapper = "_ks-2";